import React, { useState, useEffect } from 'react';
import optimizedApiService from '../services/optimizedApiService';

const PerformanceMonitor = ({ show = false }) => {
  const [stats, setStats] = useState(null);
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    if (isVisible) {
      const interval = setInterval(() => {
        const cacheStats = optimizedApiService.getCacheStats();
        setStats(cacheStats);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isVisible]);

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        className="fixed bottom-4 right-4 bg-blue-600 text-white p-2 rounded-full shadow-lg hover:bg-blue-700 z-50"
        title="Show Performance Monitor"
      >
        📊
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-xl border p-4 w-80 z-50">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-900">Performance Monitor</h3>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>
      </div>
      
      {stats && (
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Cache Entries:</span>
            <span className="font-medium">{stats.size}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Total Data Size:</span>
            <span className="font-medium">{(stats.totalDataSize / 1024).toFixed(1)} KB</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Most Accessed:</span>
            <span className="font-medium text-xs">
              {stats.entries
                .sort((a, b) => b.accessCount - a.accessCount)
                .slice(0, 1)
                .map(entry => entry.key.split(':')[0])
                .join(', ')}
            </span>
          </div>
        </div>
      )}
      
      <div className="mt-3 pt-3 border-t">
        <button
          onClick={() => optimizedApiService.clearCache()}
          className="w-full bg-red-600 text-white py-1 px-3 rounded text-sm hover:bg-red-700"
        >
          Clear Cache
        </button>
      </div>
    </div>
  );
};

export default PerformanceMonitor;